// Isolates the literal `import.meta.env` read so files that use it stay
// requireable under ts-jest, which cannot execute raw `import.meta` syntax
// outside a real ES module (see jest.config.ts moduleNameMapper).
export const isLocalDevBuild = (): boolean => import.meta.env.DEV === true;
